import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Footer } from '@/components/navigation/Footer';
import { GRATDesignerModalFooterProps } from '@/modules/entities/gratTrusts/GRATDesignerTrowser/GRATDesignerTrowser';
import { GratDesignerStages } from '@/navigation/constants';

type GratDesignerFooterProps = GRATDesignerModalFooterProps;

export function GratDesignerFooter({
  disabled,
  currentStage,
  onCloseModal,
  onChangeStage,
}: GratDesignerFooterProps) {
  return (
    <Footer
      leftAction={
        <Button
          disabled={disabled}
          onClick={onCloseModal}
          variant="secondary"
          size="sm"
        >
          Cancel
        </Button>
      }
      rightAction={
        currentStage === GratDesignerStages.BASIC_INFORMATION ? (
          <Stack direction="row" spacing={1}>
            <Button
              disabled={disabled}
              type="submit"
              variant="primary"
              size="sm"
            >
              Save and proceed
            </Button>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              disabled={disabled}
              onClick={() =>
                onChangeStage(GratDesignerStages.BASIC_INFORMATION)
              }
              variant="secondary"
              size="sm"
            >
              Previous
            </Button>
            <Button
              disabled={disabled}
              type="submit"
              variant="primary"
              size="sm"
            >
              Save and close
            </Button>
          </Stack>
        )
      }
    />
  );
}
